const layout = () => import('../../internal/dashboard/layoutV2.vue')
const notiication = () => import('./index.vue')
const post = () => import('./post.vue')
const random = () => import('./random.vue')

const notificationsRoutes = {
  component: layout,
  children: [
    {
      path: '/notifications',
      name: 'notifications',
      component: notiication,
      meta: {
        title: 'notifications',
        requiresAuth: true,
      },
    },
    {
      path: '/notifications/random',
      name: 'notificationsRandom',
      component: random,
      meta: {
        title: 'notificationsRandom',
        requiresAuth: true,
      },
    },
    {
      path: '/notifications/:id',
      name: 'notificationsPost',
      component: post,
      meta: {
        title: 'notificationsPost',
        requiresAuth: true,
      },
    },
  ],
}

export default notificationsRoutes
